import "../../../css/DesignSystem/Buttons/SecondaryButton.css";

const SecondaryButton = ({
  onClick,
  type = "button",
  disabled = false,
  label = "Previous Step",
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className="ds-secondary-btn"
    >
      <div className="Button-Text-Medium">{label}</div>
    </button>
  );
};

export default SecondaryButton;
